<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement()"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-apply">来自{{ player_data.nickName }}的邀请</div>

                    <div class="msg-view">
                        <div class="text">
                            <p v-if="fromType == 2"><b>{{ player_data.nickName }}</b>邀请您进行助力，请确认是否接受，每个ID最多助力3次</p>
                            <p v-if="fromType == 1">【<b>{{ player_data.nickName }}</b> 】邀请您进行绑定，绑定后您在消费时可为该好友提供一定比例的积分，作为回馈，您在接受绑定后可获得好友的赠礼 。</p>
                        </div>
                    </div> 
                    
                    <div class="reward-item">
                        <div class="reward-icon r-1" v-tips="'JM01'" v-if="fromType == 1">
                        </div>
                        <!-- <div class="reward-pic" v-tips="'JM02'" v-if="fromType == 2">
                            <game-item :locked="true" :id="'JM02'" :num="1"></game-item>
                        </div> -->
                        <!-- <div class="item-name">8折优惠券</div> -->
                    </div>                    

                    
                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()" v-if="!success"></div>  
                        <div class="u-btn ok" @click="apply" v-if="!success"></div>                                                                 
                    </div>

                    <div class="notice" v-if="fromType == 1">仅可接受一位好友的绑定，绑定后不可解绑！</div>

                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.t-apply{
    font-size: 26px;
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 10px 0 0;
    line-height: 1.6;
    color: #666565;

    font-size: 22px;

    b{
        padding: 0 10px;
    }
}

.notice{
    margin-top: 20px;
    text-align: center;
    color: #666565;
}

.warn{
    font-size: 32px;
    text-align: center;
    color: #de482b;
}

.reward-list{
    // margin-top: 14px;
}

.reward-item{
    width: 106px;
    margin: 10px auto;
}

.reward-pic{
    width: 69px;
    height: 69px;

    &.r-1{
        background-image: url(~@/assets/images/modal/pack-share.png);
    }

    &.r-2{
        background-image: url(~@/assets/images/modal/ticket.png);
    }        
}

.reward-icon{
    width: 87px;
    height: 101px;

    &.r-1{
        background-image: url(~@/assets/images/modal/bind-gift.png);
    }     
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 0 30px;
}

.u-btn.ok{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-invite_apply.png);    
}

.u-ctrl .u-btn.cancel{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

.notice{
    font-size : 18px;
    color : #ea583f;
}
</style>

<script>
import { apiInviteApply , apiInviteInfo ,apiButieBind } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            score : 0,
            success : false,            
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                    this.fromType = res.data.mode;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                      
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.fromType == 1 ? this.apply_team() : this.apply_butie();
        },
        apply_team (){
            apiInviteApply({ code : this.code }).then(
                res => {
                    //this.$toast('助力成功！');
                    this.destroyElement();
                    
                    this.score = res.data;
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    
                    this.$msg_modal({ title : '绑定成功' , text : '绑定成功，奖励已发放至军师邮件，<br>请注意查收！' , fromType : this.fromType});
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '绑定已上限，助力失败！' : rej.message;
                    //this.$toast(error);
                    //this.$toast(rej.message);
                    this.$msg_modal({ title : '绑定失败' , text : rej.message });
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        }, 
        apply_butie (){
            apiButieBind({ code : this.code }).then(
                res => {
                    //this.$toast('绑定成功！');
                    this.score = res.data;
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');  
                    
                    this.success = true;
                    this.destroyElement();
                    this.$msg_modal({ title : '绑定成功' , text : '助力成功，快去参与活动吧！' , fromType : this.fromType});
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '绑定已上限，绑定失败！' : rej.message;
                    //this.$toast(error);
                    this.$toast(rej.message);
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        },               
    },
}
</script>